import { useCallback, useEffect, useState } from 'react'
import { useUiStateStorageService } from '../../../../infrastructure/adaptors/uiStateStorageServiceAdaptor'

const SWIMLANE_STATE_KEY = 'KANBAN_V2_SWIMLANE_STATE'

export const useSwimlaneMode = (functionUuid: string, projectUuid: string) => {
  const [initialized, setInitialized] = useState(false)
  const [isSwimlaneEnabled, setIsSwimlaneEnabled] = useState<boolean>(false)

  const uiStateStorageService = useUiStateStorageService()

  // 復元
  useEffect(() => {
    const restore = async () => {
      const stored = await uiStateStorageService.fetch(
        functionUuid,
        `${SWIMLANE_STATE_KEY}-${projectUuid}`,
        'USER'
      )
      if (stored !== undefined && typeof stored === 'boolean') {
        setIsSwimlaneEnabled(stored)
      }
      setInitialized(true)
    }
    restore()
  }, [functionUuid, projectUuid])

  // 保存
  useEffect(() => {
    if (!initialized) return
    uiStateStorageService.save(
      functionUuid,
      `${SWIMLANE_STATE_KEY}-${projectUuid}`,
      'USER',
      isSwimlaneEnabled
    )
  }, [initialized, isSwimlaneEnabled])

  const toggleSwimlaneMode = useCallback(() => {
    setIsSwimlaneEnabled(prev => !prev)
  }, [])

  return { isSwimlaneEnabled, toggleSwimlaneMode }
}
